import axios from "axios";
import { endpoints, getPath } from "./apiUtils";
import { useMutation, useQuery } from "@tanstack/react-query";
import { AuthContext } from "../useAuth";
import { useContext } from "react";

// Request URL: https://m4w7p9314d.execute-api.us-east-1.amazonaws.com/v2/twilio/token
/*
ConversationGrant: true
Identity: "827112b1-e5fd-4b84-9d30-8b725344c7e8#Bob_Pease"
Name: "f56430c9-b136-4e14-9c3f-9146d64851af"
RoomGrant: true
RoomType: "recording"
Ttl: 5400
*/

const getToken = (identity, name, token) => {
  let path = getPath({
    endpoint: endpoints.twilio,
    path: ["token"],
  });
  return axios
    .post(
      path,
      {
        ConversationGrant: true,
        Identity: identity,
        Name: name,
        RoomGrant: true,
        RoomType: "recording",
        Ttl: 5400,
      },
      { headers: { Authorization: token } }
    )
    .then((r) => r.data);
};

export const useTwilioToken = () => {
  const { getAccessToken } = useContext(AuthContext);
  return useMutation({
    mutationFn: async ({ identity, name }) =>
      getToken(identity, name, await getAccessToken()),
  });
};
